import React, { forwardRef } from 'react';
import { format, InputMask, InputMaskProps } from '@react-input/mask';

export const maskPhoneNumber = (phoneNumber: string) => {
    return phoneNumber ? format(phoneNumber.slice(2), {mask: '(___)-___-____', replacement: '_'}) : ''
}

export const PhoneInputMask = forwardRef<HTMLInputElement, InputMaskProps>((props, forwardedRef) => {
    return <InputMask ref={forwardedRef} mask="(___)-___-____" replacement="_" {...props} />;
});